module.exports = __webpack_public_path__ + "static/img/livenone.84cdf48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/livenone.png
// module id = 8VHn
// module chunks = 1